module.exports = __webpack_public_path__ + "img/pr-3.e10415f1.png";